import { render, staticRenderFns } from "./LightDarkSwitch.vue?vue&type=template&id=73fce0c8&scoped=true&"
import script from "./LightDarkSwitch.vue?vue&type=script&lang=ts&"
export * from "./LightDarkSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LightDarkSwitch.vue?vue&type=style&index=0&id=73fce0c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73fce0c8",
  null
  
)

export default component.exports